<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="main-card" v-if="fields.length > 0">
      <!-- Local Address -->
      <v-toolbar class="custom-toolbar ma-2" v-if="localFields.length > 0" flat dense>
        <v-toolbar-title>Local / Current Address</v-toolbar-title>
      </v-toolbar>

      <v-row class="px-5">
        <template v-for="field in localFields">
          <v-col v-if="field.isactive" :key="field.field_name" :cols="field.input_type === 'textarea' ? 12 : 12"
            :sm="field.input_type === 'textarea' ? 12 : 3" :md="field.input_type === 'textarea' ? 12 : 3"
            class="pt-0 pb-0">

            <div v-if="field.input_type !== 'checkbox'" class="pl-1 pb-2" style="font-size: 14px;">
              <b>{{ field.label }}<span v-if="field.required" class="pl-1" style="color:red">*</span></b>
            </div>

            <v-text-field v-if="field.input_type === 'text'" v-model.trim="field.value" :readonly="!field.iseditable"
              :filled="!field.iseditable" dense outlined rounded />

            <v-textarea v-if="field.input_type === 'textarea'" v-model.trim="field.value" :readonly="!field.iseditable"
              :filled="!field.iseditable" dense outlined rounded />

            <v-text-field v-if="field.input_type === 'number'" v-model.trim="field.value" type="number"
              :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded />

            <v-text-field v-if="field.input_type === 'date'" v-model.trim="field.value" type="date"
              :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded />

            <div v-if="field.input_type === 'checkbox'" class="d-flex align-center pt-5">
              <v-checkbox v-model="field.value" :label="field.label" :readonly="!field.iseditable" density="compact" />
              <span v-if="field.required" class="pl-1" style="color:red">*</span>
            </div>

            <v-select v-if="field.input_type === 'select' && !field.multiple" v-model="field.value"
              :items="field.options" :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded />

            <v-autocomplete v-if="field.input_type === 'select' && field.multiple" v-model="field.value"
              :items="field.options" multiple :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined
              rounded />
          </v-col>
        </template>
      </v-row>

      <v-row class="px-5" v-if="localFields.length > 0">
        <v-col cols="12" sm="12" md="12" align="center" class="pb-5">
          <v-btn text class="button-77" @click="saveChildAddressDetails('local')">Save</v-btn>
        </v-col>
      </v-row>
      <!-- Checkbox for same address -->
      <v-divider v-if="localFields.length > 0" class="mt-5" color="navy"></v-divider>

      <v-row v-if="permanentFields.length > 0 && localFields.length > 0" class="px-5">
        <v-col cols="12" sm="12" md="12" class="pb-0">
          <v-checkbox v-model="addressDetails.pladdress" color="#0F2027"
            label="Is Permanent address same as Local / Current Address ?" @change="copyAddress()"></v-checkbox>
        </v-col>
      </v-row>


      <!-- Permanent Address -->
      <v-toolbar class="custom-toolbar ma-2" flat dense v-if="permanentFields.length > 0">
        <v-toolbar-title>Permanent Address</v-toolbar-title>
      </v-toolbar>

      <v-row class="px-5">
        <template v-for="field in permanentFields">
          <v-col v-if="field.isactive" :key="field.field_name" :cols="field.input_type === 'textarea' ? 12 : 12"
            :sm="field.input_type === 'textarea' ? 12 : 3" :md="field.input_type === 'textarea' ? 12 : 3"
            class="pt-0 pb-0">

            <div v-if="field.input_type !== 'checkbox'" class="pl-1 pb-2" style="font-size: 14px;">
              <b>{{ field.label }}<span v-if="field.required" class="pl-1" style="color:red">*</span></b>
            </div>

            <v-text-field v-if="field.input_type === 'text'" v-model.trim="field.value" :readonly="!field.iseditable"
              :filled="!field.iseditable" dense outlined rounded />

            <v-textarea v-if="field.input_type === 'textarea'" v-model.trim="field.value" :readonly="!field.iseditable"
              :filled="!field.iseditable" dense outlined rounded />

            <v-text-field v-if="field.input_type === 'number'" v-model.trim="field.value" type="number"
              :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded />

            <v-text-field v-if="field.input_type === 'date'" v-model.trim="field.value" type="date"
              :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded />

            <div v-if="field.input_type === 'checkbox'" class="d-flex align-center pt-5">
              <v-checkbox v-model="field.value" :label="field.label" :readonly="!field.iseditable" density="compact" />
              <span v-if="field.required" class="pl-1" style="color:red">*</span>
            </div>

            <v-select v-if="field.input_type === 'select' && !field.multiple" v-model="field.value"
              :items="field.options" :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined rounded />

            <v-autocomplete v-if="field.input_type === 'select' && field.multiple" v-model="field.value"
              :items="field.options" multiple :readonly="!field.iseditable" :filled="!field.iseditable" dense outlined
              rounded />
          </v-col>
        </template>
      </v-row>

      <v-row class="px-5" v-if="permanentFields.length > 0">
        <v-col cols="12" sm="12" md="12" align="center" class="pb-5">
          <v-btn text class="button-77" @click="saveChildAddressDetails('permanent')">Save</v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    learner: {
      type: [String, Number], 
      required: true,
    },
  },
  data() {
    return {
      color: "",
      snackbar: false,
      snackbar_msg: "",
      addressDetails: {
        laddress: "",
        lcity: "",
        ltaluka: "",
        ldistrict: "",
        lstate: "",
        lcountry: "",
        lpin: "",
        paddress: "",
        pcity: "",
        ptaluka: "",
        pdistrict: "",
        pstate: "",
        pcountry: "",
        ppin: "",
        pladdress: null,
      },
      fields: [],
    };
  },
  watch: {
    learner(newVal, oldVal) {
      if (newVal) {
        this.getChildAddressDetails();
      }
    },
  },
  computed: {
    localFields() {
      return this.fields.filter(f => f.field_name.startsWith("l"));
    },
    permanentFields() {
      return this.fields.filter(f => f.field_name.startsWith("p"));
    }
  },
  methods: {
    getChildAddressDetails() {
      const data = {
        learner: this.learner,
      };
      axios
        .post("/parent/getChildAddressDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fields = res.data.fields;
            this.learner_id = res.data.learner_id;
          } else if (res.data.flag == "NO") {
            this.showSnackbar("error", res.data.snackbar);
          } else {
            this.showSnackbar("error", res.data.snackbar);
          }
        })
        .catch((error) => {
          this.onerror(error);
        })
        .finally(() => { });
    },
    copyAddress() {
      if (this.addressDetails.pladdress) {
        // Copy all fields starting with 'l' to corresponding 'p'
        this.fields.forEach(field => {
          if (field.field_name.startsWith("l")) {
            const pFieldName = "p" + field.field_name.substring(1); 
            const pField = this.fields.find(f => f.field_name === pFieldName);
            if (pField) {
              pField.value = Array.isArray(field.value)
                ? [...field.value] 
                : field.value;
            }
          }
        });
      } else {
        // Clear permanent fields if unchecked
        this.fields.forEach(field => {
          if (field.field_name.startsWith("p")) {
            if (Array.isArray(field.value)) {
              field.value = [];
            } else {
              field.value = "";
            }
          }
        });
      }
    },
    saveChildAddressDetails() {
      // Generic validations
      for (let field of this.fields) {
        if (field.required) {
          if (
            field.value == null ||
            field.value === '' ||
            (Array.isArray(field.value) && field.value.length === 0)
          ) {
            const action =
              field.input_type === 'date' || field.input_type === 'select'
                ? 'select'
                : 'enter';
            this.showSnackbar("error", `Please ${action} ${field.label}`);
            return;
          }
        }
      }

      // ✅ Convert fields array → object with field_name: value
      const fieldData = this.fields.reduce((obj, field) => {
        if (Array.isArray(field.value)) {
          // join multiple selections into comma-separated string
          obj[field.field_name] = field.value.join(",");
        } else {
          obj[field.field_name] = field.value;
        }
        return obj;
      }, {});


      // ✅ Add learner_id also
      const payload = {
        learner_id: this.learner_id,
        ...fieldData
      };

      this.save_loader = true;
      axios
        .post("/parent/saveChildAddressDetails", payload)
        .then((res) => {
          if (res.data.flag === "YES") {
            this.showSnackbar("success", res.data.snackbar);
          } else {
            this.showSnackbar("error", res.data.snackbar);
          }
        })
        .catch(() => {
          this.showSnackbar("error", "Something went wrong!");
        })
        .finally(() => {
          this.save_loader = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.getChildAddressDetails();
  },
};
</script>

<style scoped>
.button-77 {
  color: #fff;
  cursor: pointer;
  font-weight: 800;
  vertical-align: middle;
  z-index: 0;
}

.button-77:before,
.button-77:after {
  border-radius: 80px;
}

.button-77:before {
  background-color: rgba(249, 58, 19, 0.32);
  content: "";
}

.button-77:after {
  background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
  bottom: 4px;
  content: "";
  display: block;
  left: 4px;
  overflow: hidden;
  position: absolute;
  right: 4px;
  top: 4px;
  transition: all 100ms ease-out;
  z-index: -1;
}

.button-77:hover:not(:disabled):after {
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  transition-timing-function: ease-in;
}

.button-77:active:not(:disabled) {
  color: #ccc;
}

.button-77:active:not(:disabled):after {
  background-image: linear-gradient(0deg,
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.2)),
    linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
  bottom: 4px;
  left: 4px;
  right: 4px;
  top: 4px;
}

.button-77:disabled {
  cursor: default;
  opacity: 0.24;
}

.main-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.custom-toolbar {
  background: linear-gradient(to right, #a8edea, #e4d0ff);
  background: linear-gradient(to right, #a8edea, #e4d0ff);
}
</style>